<template>
  <v-card class="card-rounded dialog-content">
    <v-card-title>
      <slot name="header" />
      <div class="dialog-close">
        <v-btn icon @click="$emit('close')">
          <v-icon size="24">icon-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
    <v-card-actions v-if="!!$slots['actions']">
      <div class="actions">
        <slot name="actions" />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "FileDialogWrapper"
};
</script>

<style lang="scss" scoped>
.actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: $spacing * 2;
}
</style>
